module.exports = __webpack_public_path__ + "static/media/cloud-upload.6803680c.svg";